import { FaPhoneVolume } from "react-icons/fa6";
import { FaEnvelope } from "react-icons/fa";

const HeroSection = () => {
  return (
    <section className="relative w-full h-[900px] md:h-screen md:mb-0 bg-[#F5E9D7]">
        <div className="relative w-full h-[60%] md:h-[80%] bg-contact-page-hero bg-center bg-cover">
            <div className="absolute top-0 left-0 w-full h-full bg-[#41220E] bg-opacity-70 flex items-center justify-center">
                <h1 className="text-[60px] xs:text-[50px] sm:text-[80px] xl:text-[100px] font-bold font-playfair text-white text-center md:text-start">Get In Touch</h1>
            </div>
        </div>
        <div className="absolute top-[50%] md:top-[70%] w-full h-[50%] md:h-[20%] flex flex-col md:flex-row justify-center items-center pb-8">
            <div className="xs:w-[80%] w-[320px] xl:w-[400px] h-[220px] xl:h-[280px] bg-[#FBE4C2] mx-[50px]">
                <div className="w-full h-[50%] text-[#41220E] xs:text-[60px] text-[78px] p-3 flex justify-center items-end">
                    <a href="https://www.example.com"> <FaPhoneVolume/> </a>
                </div>
                <div className="w-full h-[30%] flex flex-col justify-center items-center">
                    <p className="font-normal font-playfair xs:text-[22px] text-[25px] xl:text-[28px] text-center">+974 4148 7722</p>
                    <p className="font-normal font-playfair xs:text-[22px] text-[25px] xl:text-[28px] text-center">+974 7748 7722</p>
                </div>
                
            </div>
            <div className="xs:w-[80%] w-[320px] xl:w-[400px] h-[220px] xl:h-[280px] bg-[#FBE4C2] mx-[50px] mt-[20px] md:my-0">
                <div className="w-full h-[50%] text-[#41220E] xs:text-[60px] text-[82px] p-3 flex justify-center items-end">
                    <a href="https://www.example.com"> <FaEnvelope/> </a>
                </div>
                <div className="w-full h-[30%] flex justify-center items-center">
                    <p className="font-normal font-playfair xs:text-[22px] text-[25px] xl:text-[30px] text-center">info@thesymphonys.com</p>
                </div>
            </div>
        </div>
    </section>
  )
}

export default HeroSection
